type colorProps = {
  [key: string]: string;
};

const Color: colorProps = {
  themeColor: 'rgb(0, 122, 204)',
};

export default Color;
